/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEdit2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.086 2.836a2.078 2.078 0 00-1.47.609L4.256 16.804l-1.101 4.041 4.041-1.102 13.36-13.36a2.08 2.08 0 00-1.47-3.547zm-1.37-1.228a3.578 3.578 0 013.9 5.837l-13.5 13.5a.75.75 0 01-.333.193l-5.5 1.5a.75.75 0 01-.92-.921l1.5-5.5a.75.75 0 01.192-.333l13.5-13.5a3.578 3.578 0 011.161-.776z'
      />
    </svg>
  );
}

export default SvgEdit2;
